module.exports = __webpack_public_path__ + "assets/img/table_btn.77b86c2a.png";